<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getBranchTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionMainBranch && permissionMainBranch.permission_id === permission.readWrite"
          @click.native="clearBranchData" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.branch_id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>{{ item.branch_name_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>{{ item.orders }}</td>
              <td>
                <a v-if="item.branch_id === 0">
                  <div style="text-align: center">
                  <v-icon class="fas fa-pencil-alt" style="font-size: 20px;"></v-icon>
                  </div>
                </a>
                <a @click="showBranch(item.branch_id)" v-else>
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import CircleButton from "../../../components/Button/CircleButton";
import InputTextField from "../../../components/Input/InputTextField";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
import {permissionMainBranch, role} from "../../../util/Permission";
import Loading from 'vue-loading-overlay';
import Swal from "sweetalert";

export default {
  name: "MainBranch",
  components: {Paginate, InputSearch, InputTextField, CircleButton, IconPencil, Loading },
  created() {
    this.permission = role;
    this.getBranchTable(1);
  },
  computed:{
    permissionMainBranch,
  },
  data() {
    return {
      permission : null,
      isLoading : false,
      title: "Main Branch",
      search : '',
      sort : 'asc',
      headers: [
        { id: 1, text: "No." ,'icon' : null},
        { id: 2, text: "Branch" ,'icon' : null},
        { id: 3, text: "Update date" ,'icon' : null},
        { id: 4, text: "Order" ,'icon' : true},
        { id: 5, text: "Edit" ,'icon' : null}
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  methods: {
    goToBranchEdit() {
      this.$router.push("/branch/edit");
    },
    getBranchTable(page) {
      this.isLoading = true;
      this.$store.dispatch("Branch/getBranch", {
        page,
        search : this.search,
        sort : this.sort,
      }).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    showBranch(id) {
      this.isLoading = true;
      this.$store.dispatch("Branch/showBranch", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("Branch/setFormBranch", res.result).then(() => {
            this.goToBranchEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    clearBranchData() {
      this.$store.dispatch("Branch/clearFormData").then(() => {
        this.goToBranchEdit();
      });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getBranchTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(){
      this.sort = this.sort == 'desc' ? 'asc' : 'desc';
      console.log(this.sort);
      this.getBranchTable(1);
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/table.css";
/*.branch-data {*/
/*  background-color: transparent;*/
/*  margin: 20px;*/
/*}*/
</style>
<style>
.theme--light.v-system-bar {
  background-color: transparent !important;
  color: rgba(0, 0, 0, 0.6);
}
</style>
